import { Button } from '@components/ui/button';
import { Card, CardContent, CardHeader } from '@components/ui/card';
import { appRoutes } from '@utils/consts';
import { parseRoute } from '@utils/i18n';
import { getEnvType } from '@utils/getEnvType';
import { useIsPwa } from '@hooks/useIsPwa';
import posthog from 'posthog-js';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation, useNavigate } from 'react-router';
import { formatNotFoundReport, getNotFoundReport } from './helpers';

export const NotFound = () => {
  const navigate = useNavigate();
  const { t } = useTranslation('app', { keyPrefix: 'pages.notFound' });
  const { pathname } = useLocation();
  const isPwa = useIsPwa();
  const [report, setReport] = useState<ReturnType<typeof getNotFoundReport>>();

  useEffect(() => {
    const nextReport = getNotFoundReport(pathname, isPwa);
    setReport(nextReport);
    posthog?.capture('page_not_found', nextReport);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  return (
    <Card className="mx-auto max-w-[600px] rounded-lg border-0 font-inter shadow-card">
      <CardHeader className="flex-row">
        <h1 className="text-heading-xs font-bold">{t('title')}</h1>
      </CardHeader>
      <CardContent className="flex flex-col gap-6">
        <div className="leading-6">
          <p>{t('first')}</p>
          <p>{t('second')}</p>
        </div>
        <Link
          to=""
          onClick={(e) => {
            e.preventDefault();
            void navigate(parseRoute(appRoutes.index));
          }}>
          <Button className="w-fit">{t('action')}</Button>
        </Link>
        {getEnvType() !== 'prod' && report && (
          <pre className="whitespace-pre-wrap break-all text-xs text-neutral-400">
            {formatNotFoundReport(report)}
          </pre>
        )}
      </CardContent>
    </Card>
  );
};
